import { getFields } from "../../../../../actions/Utilities/EmailRecipient";
import { useQuery } from "react-query";

export default function useFields() {
  return useQuery("GetFields", getFields, {
    refetchOnWindowFocus: false,
  });
}
